module.exports = __webpack_public_path__ + "static/media/spindl_logo_white-xxxhdpi.e743aa1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/spindl_logo_white-xxxhdpi.png
// module id = 763
// module chunks = 0